import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { faCheck, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { AccordionModule, IconComponent } from '@pure/hive';

@Component({
    selector: 'copilot-reasoning-steps',
    standalone: true,
    imports: [AccordionModule, IconComponent],
    templateUrl: './reasoning-steps.component.html',
    styleUrl: './reasoning-steps.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReasoningStepsComponent {
    @Input() reasoningSteps: string[] = [];
    @Input() isLoading = true;

    protected readonly faCheck = faCheck;
    protected readonly faSpinner = faSpinner;
}
